import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { isTenant } from 'features/user/selectors/userSelectors';
import { breakpoints } from 'theme/variables';
import { DashboardPaths } from 'features/dashboard/models/dashboardModel';
import { UploadPaths } from 'features/upload/models/uploadModels';

const Image = styled.img<{ $collapsed?: boolean }>`
    max-width: 140px;
    transition: max-width 0.22s cubic-bezier(0.4, 0, 0.2, 1);

    ${breakpoints.small} {
        max-width: 200px;
    }
    ${breakpoints.medium} {
        max-width: ${({ $collapsed }) => ($collapsed ? '0' : '130px')};
        opacity: ${({ $collapsed }) => ($collapsed ? 0 : 1)};
        margin-top: ${({ $collapsed }) => ($collapsed ? '0' : '1.5rem')};
        margin-bottom: ${({ $collapsed }) => ($collapsed ? '0' : '1.25rem')};
        transition: max-width 0.22s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.18s ease,
            margin 0.22s cubic-bezier(0.4, 0, 0.2, 1);
    }
`;

const Mark = styled.div<{ $visible: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin: 1.25rem auto;
    border-radius: 10px;
    background: #1e7a45;
    color: #d4a520;
    font-family: 'Inter', sans-serif;
    font-weight: 800;
    font-size: 22px;
    line-height: 1;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    max-height: ${({ $visible }) => ($visible ? '40px' : '0')};
    overflow: hidden;
    transition: opacity 0.18s ease, max-height 0.22s cubic-bezier(0.4, 0, 0.2, 1),
        margin 0.22s cubic-bezier(0.4, 0, 0.2, 1);
    margin-top: ${({ $visible }) => ($visible ? '1.25rem' : '0')};
    margin-bottom: ${({ $visible }) => ($visible ? '1rem' : '0')};
`;

const StyledLink = styled(Link)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;

    :focus {
        text-decoration: none;
    }
`;

type Props = {
    onClick?: () => void;
    collapsed?: boolean;
};

export const Logo = ({ onClick, collapsed = false }: Props) => {
    const isUserTenant = useSelector(isTenant);

    return (
        <StyledLink
            to={isUserTenant ? DashboardPaths.Benefits : UploadPaths.PendingEvidence}
            onClick={onClick}
        >
            <Image
                $collapsed={collapsed}
                src="https://storage.googleapis.com/cenefits-static-assets/logo/cenefits-logo-white.png"
                alt="cenefits-logo"
            />
            <Mark $visible={collapsed}>C</Mark>
        </StyledLink>
    );
};
